// extracted by mini-css-extract-plugin
export default {"risk-title":"_risk-title_5PfVIt","score":"_score_fHUP3U"};